module.exports = __webpack_public_path__ + "static/MaterialCommunityIcons-5a293a273bee8d740a045d9922b9a9ae.ttf";